import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, DatePicker, Flex, Form, FormProps, Input } from 'antd';
import { SelectProps } from 'antd/lib';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import CompanyContactInfoModal from '@/components/general/CompanyContactInfoModal';
import { useCountryContext } from '@/contexts/CountryContext';
import { PaymentsChoicesString } from '@/model/Logistic/Shipper/ShipperPayment';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';

interface ShipmentDetailFormProps {
  formProps: FormProps;
  companySelectProps: SelectProps;
  shippersSelectProps: SelectProps;
  ticketsSelectProps: SelectProps;
  edit?: boolean;
}

const ShipmentDetailForm = (props: ShipmentDetailFormProps) => {
  const { isBrasilSelected } = useCountryContext();
  const { t } = useTranslation();
  const { companyRepository } = useRepositoriesContext();
  const { formProps, companySelectProps, shippersSelectProps } = props;
  const company = Form.useWatch('company', formProps.form);

  return (
    <>
      <div className="ShipmentFormRow">
        <Form.Item label={t('Empresa o Técnico que recibirá el paquete')} required>
          <Flex align="center" gap={4}>
            <Form.Item
              name={'company'}
              rules={[
                {
                  required: true,
                  message: t('La empresa o técnico que recibe es requerida'),
                },
                {
                  warningOnly: true,
                  validator: async (_, value) => {
                    if (!value) return Promise.resolve();

                    const contacts = await companyRepository.getCompanyContact(value);

                    if (contacts.length === 0) {
                      return Promise.reject(
                        new Error(t('La empresa o técnico no tiene un contacto asignado')),
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
              noStyle>
              {/* <CompanySelector
                showFullName
                {...companySelectProps}
                allowClear
                showSearch
                onChange={(v, opt) => {
                  companySelectProps?.onChange?.(v, opt);

                  formProps.form?.setFieldValue('shipment_cuit', (opt as any)?.item?.cuit || '');
                }}
              /> */}
              <AntdSelect
                {...companySelectProps}
                allowClear
                showSearch
                onChange={(v, opt) => {
                  companySelectProps?.onChange?.(v, opt);

                  formProps.form?.setFieldValue('shipment_cuit', (opt as any)?.item?.cuit || '');
                }}
              />
            </Form.Item>
            {company && (
              <CompanyContactInfoModal
                company={company}
                openButton={<Button icon={<InfoCircleOutlined />} />}
              />
            )}
          </Flex>
        </Form.Item>

        <Form.Item
          label={isBrasilSelected ? 'CPF/CNPJ' : 'CUIT'}
          name={'shipment_cuit'}
          rules={[
            {
              required: true,
              message: t(isBrasilSelected ? 'El CPF/CNPJ es requerido' : 'El CUIT es requerido'),
            },
          ]}>
          <Input />
        </Form.Item>
      </div>
      <div className="ShipmentFormRow">
        <Form.Item
          label={t('Operador logístico')}
          name={'shipper'}
          rules={[
            {
              required: true,
              message: t('El operador logístico es requerido'),
            },
          ]}>
          <AntdSelect {...shippersSelectProps} allowClear showSearch />
        </Form.Item>
        <Form.Item
          label={t('Tipo de pago')}
          name={'shipper_payment'}
          rules={[
            {
              required: true,
              message: t('El tipo de pago es requerido'),
            },
          ]}>
          <AntdSelect
            options={Object.entries(PaymentsChoicesString).map(([value, label]) => ({
              value: parseInt(value),
              label: t(label),
            }))}
            allowClear
          />
        </Form.Item>
      </div>
      <div className="ShipmentFormRow">
        <Form.Item
          label={t('Fecha de envío estimada')}
          name={'date_estimated'}
          rules={[
            {
              required: true,
            },
          ]}
          getValueProps={value => ({
            value: value ? dayjs(value) : undefined,
          })}
          className="ShipmentFormDatePicker">
          <DatePicker minDate={dayjs()} format={'L'} placeholder={t('Seleccionar una fecha')} />
        </Form.Item>
        <Form.Item label={t('Observaciones')} name={['comment']}>
          <Input />
        </Form.Item>
      </div>
    </>
  );
};

export default ShipmentDetailForm;
